var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSideLineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.06 48.24C40.66 48.24 42.4 46.4 42.4 43.96C42.4 41 39.6 40.34 37.4 39.84C35.86 39.48 34.74 39.2 34.74 38.3C34.74 37.5 35.42 36.94 36.7 36.94C38 36.94 39.44 37.4 40.52 38.4L42.1 36.32C40.6706 35.054 38.8081 34.3878 36.9 34.46C33.76 34.46 31.84 36.26 31.84 38.48C31.84 41.46 34.64 42.06 36.82 42.56C38.36 42.92 39.52 43.26 39.52 44.26C39.52 45.02 38.76 45.76 37.2 45.76C35.36 45.76 33.9 44.94 32.96 43.96L31.4 46.12C32.66 47.38 34.5 48.24 37.06 48.24ZM47.16 48V34.66H44.32V48H47.16V48ZM55.06 48C59.24 48 62.14 45.36 62.14 41.34C62.14 37.32 59.24 34.66 55.06 34.66H49.8V48H55.06V48ZM55.06 45.5H52.64V37.16H55.06C57.8 37.16 59.24 38.98 59.24 41.34C59.2628 41.8941 59.1701 42.4469 58.9678 42.9632C58.7655 43.4796 58.4581 43.9482 58.065 44.3394C57.6719 44.7306 57.2018 45.0358 56.6845 45.2356C56.1672 45.4354 55.614 45.5254 55.06 45.5V45.5ZM73.6 48V45.54H67V42.44H73.46V40H67V37.1H73.6V34.66H64.16V48H73.6ZM40.8 65V62.5H35.16V51.66H32.32V65H40.8ZM45.62 65V51.66H42.78V65H45.62ZM51.1 65V56.04L57.46 65H60.2V51.66H57.36V60.3L51.18 51.66H48.26V65H51.1V65ZM72.28 65V62.54H65.68V59.44H72.14V57H65.68V54.1H72.28V51.66H62.84V65H72.28Z",
    fill: "#737e8c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 33V67",
    stroke: "#ff0089",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideLineIcon);
export default __webpack_public_path__ + "static/media/SideLine-icon.501f893c3dc9278fac7a2d16861b2cf3.svg";
export { ForwardRef as ReactComponent };